import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type HeadingProps } from "@client/controls/HTML/Heading/component";
import { withIsVisible } from "@client/hocs";
import React from "react";

export type MapProps = RootContainerProps & {
  horizontalAlign: "left" | "center" | "right" | "justify";
  headingProps: HeadingProps;
  title: string;
};

export type ActionProps = {};

export default withIsVisible((props: ActionProps & MapProps) => (
  <div style={{ textAlign: props.horizontalAlign }}>
    <props.TextComponent
      {...getEntityRef(props)}
      toolbar={"basic"}
      prop="heading"
      style={props.headingProps.style ?? undefined}
      tag={props.headingProps.level}
      html={props.title}
    />
  </div>
));
